import { SD_MonacoEditor } from '../Utility/StaticDatas';
import prettier from 'prettier/standalone';
import babelPlugin from 'prettier/plugins/babel';
import htmlPlugin from 'prettier/plugins/html';
import postcssPlugin from 'prettier/plugins/postcss';

const getPrettierParserForLanguage = (language: string) => {
  switch (language) {
    case SD_MonacoEditor.JS:
      return 'babel';
    case SD_MonacoEditor.HTML:
      return 'html';
    case SD_MonacoEditor.CSS:
      return 'css';
    default:
      return 'babel'; // Default parser
  }
};

const codeFormatter = async (code: string, defaultLanguage: string) => {
  const parser = getPrettierParserForLanguage(defaultLanguage);
  try {
    const formattedCode = await prettier.format(code, {
      parser,
      plugins: [babelPlugin, htmlPlugin, postcssPlugin],
    });
    return formattedCode;
  } catch (error) {
    return code; // Return unformatted code in case of an error
  }
};

export default codeFormatter;
